import { DataFlowFeedback } from "@/model/data/dataflow/DataFlowFeedback";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/dataflow/feedbacks";

export class GetDataFlowFeedbacksByTransactionIdCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any;

    constructor(transactionId: string) {
        super();
        this.params = { transactionId: transactionId };
    }

    public async execute(): Promise<GetDataFlowFeedbacksByTransactionIdResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetDataFlowFeedbacksByTransactionIdResData(res);
    }
}

export class GetDataFlowFeedbacksByTransactionIdResData extends ApiGenericResponse {
    feedbacks: DataFlowFeedback[];

    constructor(response: AxiosResponse) {
        super(response);
        this.feedbacks = [];

        if (response.data && response.data.Payload && Array.isArray(response.data.Payload.Feedbacks) && response.data.Payload.Feedbacks.length)
            this.parse(response.data.Payload.Feedbacks);
    }

    public parse(feedbacks: any) {
        feedbacks.forEach((feedbackToParse) => {
            var feedback: DataFlowFeedback = new DataFlowFeedback();
            feedback.parse(feedbackToParse);
            this.feedbacks.push(feedback);
        });
    }
}
